import React from 'react';

import { Link } from '@interlayer/js/components/common/Link';

import { componentService } from '@core/js/services/component.service';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TLogoProps } from './types';

import style from './Logo.scss';

export const Logo: React.FC<TLogoProps> = ({
    href,
    className,
    inNewWindow,
    size,
    isCenter,
    onClick
}) => {
    const LogoComponent = () => (
        <div className={style.container}>
            <div className={style.icon} />
        </div>
    );

    return (
        <div
            data-testid="Logo__logo"
            style={{ width: size, height: size }}
            className={clsx('logo', style.logo, className, { [style.isCenter]: isCenter })}
            {...onClick && { onClick }}
        >
            {href
                ? (
                    <Link
                        href={href}
                        inNewWindow={inNewWindow}
                        className={style.logoLink}
                    >
                        <LogoComponent />
                    </Link>
                )
                : <LogoComponent />
            }
        </div>
    );
};

componentService.registerWebContentComponents({ Logo });
